<template lang="pug">
#banner
  swiper.swiper-container(:options="swiperOption", ref="mySwiper")
    swiper-slide.swiper-slide(
      v-for="(banner, index) in bannerList",
      :key="index"
    )
      section.single-item.slider.mask
        .list.d-flex.align-items-center.justify-content-center(
          style="cursor: pointer",
          :style="{ backgroundImage: 'url(' + banner.photo.image + ')' }",
          @click="bannerClick(banner)"
        )
          .text.text-center
            h3.text-white {{ banner.title }}
            p.text-white {{ banner.content }}
    .swiper-pagination.swiper-pagination-white(slot="pagination")
</template>

<script>
import { getIndexBannerList } from "@/api/index";
import { mixins } from "@/mixins/mixins.js";

export default {
  name: "Banner",
  mixins: [mixins],
  data() {
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 1,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      bannerList: [],
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
  },
  methods: {
    initialLanguage() {
      this.getIndexBannerList();
    },
    getIndexBannerList() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getIndexBannerList(temp).then((response) => {
        this.bannerList = response.data;
      });
    },
    toUrl(url) {
      window.open(url);
    },
    bannerClick(banner) {
      this.linkClick(banner.link);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/banner";
</style>
